import Layout from '@/Layout';
import Home from '@/pages/Home';
import PageNotFound from '@/pages/NotFound';
import QrRegistrar from '@/pages/QrRegistrar';
import JWTProvider from '@/providers/JWTProvider';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './App.css';
import Interested from "@/pages/Interested";
import type React from "react";

const App = (): React.ReactElement => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Layout />}>
                    <Route index element={<JWTProvider><Home /></JWTProvider>} />
                </Route>
                <Route path='/interested-form/:activityId' element={<Layout />}>
                    <Route index element={<Interested />} />
                </Route>
                <Route path='/qr/:actionItem/:activityId' element={<Layout />}>
                    <Route index element={<JWTProvider><QrRegistrar /></JWTProvider>} />
                </Route>
                <Route path='*' element={<><Layout /><PageNotFound /></>} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
